export default __webpack_public_path__ + "c176edeeb18c21b9dfb8f18fa93e4acd.png";